<template>
  <Modal
    class="cc-modal"
    width="700"
    footer-hide
    v-model="visibility"
    :title="title"
  >
    <div class="content" style="position: relative">
      <loading  :loading="loading" style="z-index: 11"></loading>
      <div class="section" v-if="details">
        <div class="row row-border">
          <div class="name">域名：</div>
          <div
            class="row"
            style="flex: 1; justify-content: space-between; padding-right: 40px"
          >
            <div>{{ details.ym }}</div>
            <div>
              <Button @click="onShowCertificate">查看证书</Button>
              <Button style="margin-left: 10px" @click="onDownloadCertificate"
                >下载证书</Button
              >
            </div>
          </div>
        </div>
        <div class="row row-border">
          <div class="name">注册时间：</div>
          <div class="name">{{ details.registrationTime }}</div>
        </div>
        <div class="row row-border">
          <div class="name">过期时间：</div>
          <div
            class="row"
            style="flex: 1; justify-content: space-between; padding-right: 40px"
          >
            <div>{{ details.expirationTime }}</div>
            <div>
              <Button :loading="renewLoading" @click="req_renew">续费</Button>
            </div>
          </div>
        </div>
        <div class="row row-border">
          <div class="name">域名状态：</div>
          <div
            class="row"
            :style="{
              flex: '1',
              'justify-content': 'space-between',
              'align-items':
              details.statusList && details.statusList.length > 1 ? 'start' : 'center',
              'padding-right': '40px',
            }"
          >
            <div v-if="details.statusList">
              <div
                class="row"
                v-for="item in details.statusList"
                :key="item.name"
              >
                <div class="t-name">{{ item.desc }}</div>
                <div class="label">{{ item.name }}</div>
              </div>
            </div>
            <Button
              :style="{
                'margin-top': details.statusTypeList &&  details.statusTypeList.length > 1 ? '14px' : '0',
              }"
              @click="onShowDomainStatus"
              >域名状态说明</Button
            >
          </div>
        </div>
        <div class="row row-border">
          <div class="name">域名所有人：</div>
          <div>{{ details.owner }}</div>
        </div>
        <div class="row row-border">
          <div class="name">实名证件类型：</div>
          <div>{{ details.type }}</div>
        </div>
        <div class="row">
          <div class="name">实名证件号码：</div>
          <div>{{ details.num }}</div>
        </div>
      </div>
    </div>
    <!-- <div class="foot">
      <Button
        @click="visibility = false"
        type="primary"
        style="margin-right: 20px"
        >确定</Button
      >
    </div> -->
    <domainStatusModal
      :show.sync="domainStatusModalVisibility"
      :data="domainStatusData"
    ></domainStatusModal>
    <domainCertificateModal
      :show.sync="domainCertificateModalVisibility"
      :data="domainCertificateData"
    ></domainCertificateModal>
    <renewListModal
      :show.sync="renewModalVisibility"
      :title="renewModalTitle"
      :data="renewList"
    ></renewListModal>
  </Modal>
</template>
<script>
import { domainDetail, getDownloadDomainPicById } from "api/user.js";
import { addShopCart } from "api/domain.js";
import loading from "components/loading.vue";
import domainStatusModal from "components/domain/domainStatusModal.vue";
import domainCertificateModal from "components/domain/domainCertificateModal.vue";
import renewListModal from "components/domain/renewListModal.vue";
export default {
  name: "domainDetailModal",
  components: {
    loading,
    domainStatusModal,
    domainCertificateModal,
    renewListModal,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      details: {
        statusList: [],
      },
      loading: false,
      // 域名状态
      domainStatusModalVisibility: false,
      domainStatusData: [],
      // 域名证书
      domainCertificateModalVisibility: false,
      domainCertificateData: {
        loading: false,
        path: "",
      },
      // 续费
      renewModalVisibility: false,
      renewList: [],
      renewModalTitle: "",
      renewLoading: false,
    };
  },
  watch: {
    data: {
      immediate: true,
      deep: true,
      handler(val) {
        if (val.dn) {
          this.req_domainDetail();
        }
      },
    },
  },
  computed: {
    visibility: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit("update:show", val);
      },
    },
    title() {
      return this.data && this.data.dn ? this.data.dn + " 详情" : "";
    },
  },
  methods: {
    // 域名详情
    async req_domainDetail() {
      try {
        const params = {
          dnId: this.data.id,
        };
        this.loading = true;
        const { code, data } = await domainDetail(params);
        this.loading = false;
        if (code === 200 && data) {
          this.details = data;
          this.domainCertificateData.path = "";
        }
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },
    // 域名状态说明
    onShowDomainStatus() {
      this.domainStatusModalVisibility = true;
      this.domainStatusData = this.details.statusTypeList;
    },
    // 查看证书
    onShowCertificate() {
      this.domainCertificateModalVisibility = true;
      if (!this.domainCertificateData.path) {
        this.req_getCertificate(true);
      }
    },
    // 下载证书
    async onDownloadCertificate() {
      if (!this.domainCertificateData.path) {
        await this.req_getCertificate();
      }
      this.download();
    },
    dataURLtoBlob(dataurl) {
      const arr = dataurl.split(",");
      const mime = arr[0].match(/:(.*?);/)[1];
      const bstr = atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: mime });
    },
    download() {
      const data = this.dataURLtoBlob(this.domainCertificateData.path);
      const type = data.type.split("/")[1];
      const imageUrl = URL.createObjectURL(data);
      const a = document.createElement("a");
      a.setAttribute("href", imageUrl);
      a.setAttribute("download", `${this.details.ym}证书信息.${type}`);
      a.setAttribute("target", "_blank");
      const clickEvent = document.createEvent("MouseEvents");
      clickEvent.initEvent("click", true, true);
      a.dispatchEvent(clickEvent);
    },
    // 请求证书
    async req_getCertificate() {
      try {
        this.domainCertificateData.loading = true;
        const params = {
          domainId: this.data.id,
        };
        const { code, data, message } = await getDownloadDomainPicById(params);
        this.domainCertificateData.loading = false;
        if (code === 200) {
          this.domainCertificateData.path = data;
        } else {
          this.$Message.warning(message);
        }
      } catch (error) {
        this.domainCertificateData.loading = false;
        console.log(error);
      }
    },
    // 续费
    async req_renew() {
      try {
        let params = {
          domains: [this.details.ym],
          type: 1,
        };
        this.renewLoading = true;
        const { code, data, result } = await addShopCart(params);
        this.renewLoading = false;
        if (code === 200 && result && data.length === 0) {
          this.$Message.success("添加成功！");
          setTimeout(() => {
            window.location.href = "/cart";
          }, 1000);
        } else {
          this.renewModalVisibility = true;
          this.renewModalTitle = "域名续费结果";
          this.renewList = data;
        }
      } catch (error) {
        this.renewLoading = false;
        console.log(error);
      }
    },
  },
};
</script>
<style lang="less" scoped>
.cc-modal {
  .content {
    height: auto;
    min-height: 100px;
    max-height: 500px;
    overflow: auto;
    padding-bottom: 20px;
  }
  .foot {
    border-top: 1px solid #dcdee2;
    padding-top: 16px;
    display: flex;
    justify-content: flex-end;
  }
}
.col {
  margin-left: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-bottom: 20px;
  .name {
    color: #333333;
    font-size: 16px;
    margin-bottom: 10px;
  }
  .label {
    color: #999999;
  }
}
.name.required {
  &::before {
    content: "*";
    color: #ed1d33;
    margin-right: 5px;
  }
}
.upload-section {
  width: 200px;
  height: 122px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  .icon {
    width: 45px;
    height: 35px;
  }
}
.icon2 {
  border: 1px dashed #dcdee2;
  position: relative;
  width: 200px;
  height: 122px;
  background-size: cover;
  background-position: center;
  .close {
    position: absolute;
    right: 5px;
    top: 5px;
    cursor: pointer;
  }
}
.row.row-border {
  border-bottom: 1px dashed #dcdee2;
}
.row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  line-height: 50px;
  .name {
    color: #333333;
    min-width: 120px;
    text-align: right;
    margin-right: 20px;
  }
  .t-name {
    color: #333333;
    margin-right: 20px;
  }
  .label {
    color: #2d8cf0;
  }
}
.fixed {
  top: 51px;
  bottom: 64px;
  transform: translateX(-50%);
  height: auto;
}
</style>
<style lang="less" scoped>
::v-deep .height45 {
  .ivu-input[disabled] {
    color: #333;
  }
  .ivu-input {
    height: 45px;
    line-height: 45px;
  }
  .ivu-input-icon {
    line-height: 45px;
  }
  .ivu-input-with-prefix {
    padding-left: 60px;
  }
  .ivu-input-prefix {
    width: 60px;
    padding: 0 10px;
  }
  .ivu-select-selection {
    height: 45px;
  }
  .ivu-select-input {
    height: 45px;
  }
  .ivu-select-selected-value {
    height: 45px;
    line-height: 45px;
  }
  .ivu-select-placeholder {
    height: 45px;
    line-height: 45px;
  }
  .ivu-input-prefix i,
  .ivu-input-suffix i {
    line-height: 45px;
  }
}
</style>
